import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';

export class ItemsStore {
  private _storeAvailableStockWarning: number;

  constructor() {
    this.storeAvailableStockWarning = 0;
  }

  clone(data: ItemsStore){
    this.storeAvailableStockWarning = data.storeAvailableStockWarning;
  }

  fromJson(data: ItemsStore){
    this.storeAvailableStockWarning = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.storeAvailableStockWarning], null);
  }


  get storeAvailableStockWarning(): number {
    return this._storeAvailableStockWarning;
  }

  set storeAvailableStockWarning(value: number) {
    this._storeAvailableStockWarning = value;
  }

  toMap(){
     return{
       'storeAvailableStockWarning': this.storeAvailableStockWarning,
     }
  }
}
